import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
/* A 112px re-export of the brand mark: the full-size logo.jpg is 91KB
   for a 34px slot, which is the page's only real asset waste. */
import logoMark from '../../assets/images/logo-mark.jpg';
import { NAV_LINKS, ROUTES } from '../data/content';
import { subscribeToScroll } from '../hooks/scrollEngine';
import MagneticButton from '../components/MagneticButton';
import { Menu } from '../components/icons';

/* ==================================================================
   Navbar
   ------------------------------------------------------------------
   Sticky. Past the first screen-fold threshold it condenses and
   picks up a blurred glass background. The scroll listener is the
   shared engine and it only ever flips one boolean, so the nav does
   not re-render while scrolling.
   ================================================================== */

const CONDENSE_AT = 40;

export default function Navbar() {
  const [condensed, setCondensed] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    let state = false;
    return subscribeToScroll({
      measure: () => window.scrollY || window.pageYOffset || 0,
      apply: (y) => {
        const next = y > CONDENSE_AT;
        if (next !== state) {
          state = next;
          setCondensed(next);
        }
      },
    });
  }, []);

  /* Keep the page behind a full-screen mobile menu from scrolling. */
  useEffect(() => {
    if (!menuOpen) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener('keydown', onKey);
    };
  }, [menuOpen]);

  return (
    <header className={`hs-nav ${condensed ? 'is-condensed' : ''}`}>
      <div className="hs-nav__inner">
        <Link to="/" className="hs-nav__brand" onClick={() => setMenuOpen(false)}>
          <img src={logoMark} alt="" width="34" height="34" decoding="async" />
          <span>HyrSkill</span>
        </Link>

        <nav className="hs-nav__links" aria-label="Sections">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href}>
              <span>{link.label}</span>
            </a>
          ))}
        </nav>

        <div className="hs-nav__actions">
          <Link to={ROUTES.login} className="hs-nav__login">Login</Link>
          <MagneticButton to={ROUTES.studentSignup} variant="primary" size="sm" strength={5}>
            Get Started
          </MagneticButton>
        </div>

        <button
          type="button"
          className="hs-nav__burger"
          aria-expanded={menuOpen}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <Menu open={menuOpen} />
        </button>
      </div>

      <div className={`hs-sheet ${menuOpen ? 'is-open' : ''}`} aria-hidden={!menuOpen}>
        <nav className="hs-sheet__links" aria-label="Sections">
          {NAV_LINKS.map((link, i) => (
            <a
              key={link.href}
              href={link.href}
              style={{ '--hs-i': i }}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
        </nav>
        <div className="hs-sheet__actions">
          <Link to={ROUTES.login} className="hs-btn hs-btn--ghost hs-btn--md" onClick={() => setMenuOpen(false)}>
            <span className="hs-btn__label">Login</span>
          </Link>
          <Link to={ROUTES.studentSignup} className="hs-btn hs-btn--primary hs-btn--md" onClick={() => setMenuOpen(false)}>
            <span className="hs-btn__label">Get Started</span>
          </Link>
        </div>
      </div>
    </header>
  );
}
